import React from 'react';
import styled from 'styled-components';
import { media } from 'theme';

const Wrapper = styled.div`
  text-align: center;
  width: 904px;
  margin: 0 auto;
  margin-top: 153px;
  margin-bottom: 80px;
  padding: 0 22px;

  h1 {
    font-size: 26px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
  }

  ${media.largeAndDown`
    width: 100%;
    margin-top: 75px;
    margin-bottom: 65px;
  `}
`;

const PageHeaderSection = ({ title, subtitle }) => {
  return (
    <Wrapper>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </Wrapper>
  );
};

export default PageHeaderSection;
